module.exports = __webpack_public_path__ + "static/media/add_order.33754174.wav";